import { toast } from "react-toastify";
import { createListenerMiddleware, ListenerEffectAPI, TypedStartListening } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query/react";
import { authByOAuthTelegram, authByOAuthToken, fastLogin, loginUser } from "@app/store/authSlice";
import { showCompareForm } from "@app/store/layoutSlice";
import { mergeFavorites, offersApi } from "@app/store/offersApi";
import { AppDispatch, AppState } from "@app/store/store";
import { compareApi, loadCompareOffersFromLocalStorage } from "@entities/compare";
import { saveCompareOffersToLocalStorage } from "@entities/compare/lib";
import { applyThemeByUserType } from "@shared/lib/theme";
import { ERROR_SYNC_COMPARE } from "./constants";

export const loginListenerMiddleware = createListenerMiddleware();

export type LoginStartListening = TypedStartListening<AppState, AppDispatch>;

const startListening = loginListenerMiddleware.startListening as LoginStartListening;

startListening({
    actionCreator: loginUser.fulfilled,
    effect: async (_, api) => {
        await handleFavoriteSync(api);
        await handleCompareSync(api);
        syncThemeFromStorage();
    }
});

startListening({
    actionCreator: fastLogin.fulfilled,
    effect: async (_, api) => {
        await handleFavoriteSync(api);
        await handleCompareSync(api);
        syncThemeFromStorage();
    }
});

startListening({
    actionCreator: authByOAuthToken.fulfilled,
    effect: async (_, api) => {
        await handleFavoriteSync(api);
        await handleCompareSync(api);
        syncThemeFromStorage();
    }
});

startListening({
    actionCreator: authByOAuthTelegram.fulfilled,
    effect: async (_, api) => {
        await handleFavoriteSync(api);
        await handleCompareSync(api);
        syncThemeFromStorage();
    }
});

async function handleFavoriteSync(api: ListenerEffectAPI<AppState, AppDispatch>) {
    await api.dispatch(mergeFavorites());
    api.dispatch(offersApi.util.invalidateTags(["Favorites"]));
}

async function handleCompareSync(api: ListenerEffectAPI<AppState, AppDispatch>) {
    const offers = loadCompareOffersFromLocalStorage();
    if (!offers.length) return;

    try {
        await api
            .dispatch(
                compareApi.endpoints.mergeOffersComparison.initiate({
                    offerUuids: offers,
                    isRewrite: false
                })
            )
            .unwrap();

        saveCompareOffersToLocalStorage([]);
    } catch (e) {
        const error = e as FetchBaseQueryError;

        if (error?.status === 409) {
            api.dispatch(showCompareForm());
        } else {
            toast.error(ERROR_SYNC_COMPARE);
        }
    }
}

function syncThemeFromStorage(): void {
    if (typeof window === "undefined") return;

    const raw = localStorage.getItem("user");
    const user = raw ? JSON.parse(raw) : null;
    applyThemeByUserType(user?.isCompany);
}